import React from 'react';
import {observer, inject} from 'mobx-react';
import {Modal} from '@enos/dpl';
import localeText, {getLocale} from '@locale';
import {getPublicKey} from '~/utils/encrypt';
import MobileNavBack from '~/components/MobileNavBack';
import CompanySwitchList, {showCompanySwitchModal} from '~/components/CompanySwitchList';
import ChangeCipher, {showChangePasswordModal} from '~/components/ChangeCipher';
import LanguageSwitch, {showLanguageSwitcherModal} from '~/components/LanguageSwitchList';
import {formatLanToText} from '~/utils/tools';
import './mobile.less';
import store from '../store';
import userInfoBg from '~/assets/images/user_info_bg.svg';

@inject((stores, props) => {
  const {sessionStore, securityStore} = stores;
  return {
    ...props,
    sessionStore,
    securityStore,
    uiStore: store
  };
})

@observer
class Setting extends React.Component {
  static defaultProps = {
    prefixClass: 'component-mobile-portal-setting'
  };

  currentLan = () => {
    const {sessionStore} = this.props;
    const lan = sessionStore.languagesConfig.includes(getLocale()) ? getLocale() : sessionStore.languagesConfig[0];
    return lan;
  }

  render() {
    const {sessionStore, uiStore, prefixClass} = this.props;
    const {currentUser: user} = sessionStore;
    return (
      <Modal
        className={prefixClass}
        closable={false}
        visible={uiStore.showSetting}
        footer={null}
        onClose={() => uiStore.toggleSettingModal(false)}
      >
        <MobileNavBack title={localeText('COMMON.TITLE_SETTING')} onBack={() => uiStore.toggleSettingModal(false)} />
        <div className='setting-content'>
          <div className='setting-user-info' style={{background: `url(${userInfoBg})`}}>
            <div className='info'>
              <div className='name'>{user.name}</div>
              <div className='email'>{user.email}</div>
            </div>
          </div>
          <div className='setting-option'>
            <div className='setting-switch-company-org' onClick={showCompanySwitchModal}>
              <div className='left'>
                <i className='dpl20_structure' />
                <span>{localeText('COMMON.BTN_CHANGE_ORGANIZATION')}</span>
              </div>
              <div className='right'>
                <i className='dpl20_right_s' />
              </div>
            </div>
            <div className='setting-lan-switch' onClick={showLanguageSwitcherModal}>
              <div className='left'>
                <i className='dpl20_language' />
                <span>{localeText('COMMON.BTN_LAN_SWITCH')}</span>
              </div>
              <div className='right'>
                <span> {formatLanToText(this.currentLan())}</span>
                <i className='dpl20_right_s' />
              </div>
            </div>
            {!user.domain && (
              <div
                className='setting-change-password'
                onClick={
                  () => {
                    getPublicKey().then(() => {
                      this.props.securityStore.getPasswordRule(this.props.sessionStore.currentUser.id);
                      showChangePasswordModal();
                    });
                  }
                }
              >
                <div className='left'>
                  <i className='dpl20_lock' />
                  <span>{localeText('COMMON.BTN_CHANGE_CIPHER')}</span>
                </div>
                <div className='right'>
                  <i className='dpl20_right_s' />
                </div>
              </div>
            )}
          </div>
          <div className='setting-exit' onClick={sessionStore.logout}>
            <i className='dpl20_logout' />
            <span>{localeText('COMMON.BTN_LOGOUT')}</span>
          </div>
        </div>
        <ChangeCipher />
        <CompanySwitchList />
        <LanguageSwitch />
      </Modal>
    );
  }
}

export default Setting;
